import { render } from "./StudentStatisticsView.vue?vue&type=template&id=bc5b9456&scoped=true"
import script from "./StudentStatisticsView.vue?vue&type=script&lang=js"
export * from "./StudentStatisticsView.vue?vue&type=script&lang=js"

import "./StudentStatisticsView.vue?vue&type=style&index=0&id=bc5b9456&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5b9456"]])

export default __exports__